import { useEffect, useState } from 'react';
import { Box, ButtonBase, Dialog, makeStyles, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import moment from 'moment';
import { CloseIcon } from '../../../../../components/Icon';
import StyleButton from '../../../../../components/StyleButton';
import TableUI from '../../../../../components/TableUI';
import Text from '../../../../../components/Text';
import BusStopUI from '../../BusStop/components/BusStopUI';
import { eadmissionAPI } from '../../../../../apis';

const useStyles = makeStyles(() => ({
  dislog: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
    },
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
  },
  status: {
    fontSize: '1rem',
    color: '#2E4469',
    fontFamily: 'NotoSans-Medium',
  },
  statusCircle: {
    width: '0.625rem',
    height: '0.625rem',
    borderRadius: '50%',
  },
  tableHead: {
    '& .MuiTableCell-root': {
      fontSize: '0.75rem !important',
      padding: '0 1rem 0 0 !important',
    },
  },
  tableBody: {
    '& .MuiTableCell-root': {
      fontSize: '0.875rem !important',
      padding: '1rem 1rem 0 0 !important',
      color: '#2E4469 !important',
      borderBottom: 'unset !important',
    },
  },
}));

function BusStopPopup({ handleClose, busStopInfo, hold, gender, eaId }) {
  const classes = useStyles();
  const [showHistory, setShowHistory] = useState(false);
  const [historyList, setHistoryList] = useState([]);
  const [getHistorySuccess, setGetHistorySuccess] = useState(false);

  const getHistory = async () => {
    try {
      const params = {
        eaId,
      };
      const { result } = await eadmissionAPI.getTicketHistory(params);
      setHistoryList(result);
      setGetHistorySuccess(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getHistory();
  }, []);

  useEffect(() => {
    if (showHistory && !getHistorySuccess) {
      getHistory();
    }
  }, [showHistory, getHistorySuccess]);

  return showHistory ? (
    <Dialog className={classes.dislog} open={true}>
      <Box p="1.875rem 2.5rem" borderRadius="0.9375rem" width="43.125rem">
        <Box display="flex" justifyContent="space-between">
          <Text fontSize="1.25rem" color="#2E4469">
            Ack. History
          </Text>
          <Box display="flex" gridGap="0.5rem">
            <ButtonBase
              onClick={() => {
                setShowHistory(false);
              }}
            >
              <CloseIcon className={classes.closeIcon} />
            </ButtonBase>
          </Box>
        </Box>
        <Box m="1rem 0">
          <TableUI>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell>Ack. Date</TableCell>
                <TableCell>Ward</TableCell>
                <TableCell>Ack.By</TableCell>
                <TableCell>Actionable type</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBody}>
              {historyList.map((item) => (
                <TableRow key={JSON.stringify(item)}>
                  <TableCell>{moment(item.ackDate).format('YYYY-MM-DD HH:mm')}</TableCell>
                  <TableCell>{item.ward}</TableCell>
                  <TableCell>{item.ackBy}</TableCell>
                  <TableCell>{item.actionAbleType}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </TableUI>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="center">
          <StyleButton
            width="12.5rem"
            height="2.875rem"
            text="Back"
            onClick={() => {
              setShowHistory(false);
            }}
          />
        </Box>
      </Box>
    </Dialog>
  ) : (
    <Dialog className={classes.dislog} open={true}>
      <Box p="0 2.5rem">
        <Box display="flex" justifyContent="flex-end" m="1rem 0">
          <Box
            mr="2.72rem"
            p="0.88rem 1.88rem"
            border="1px solid rgba(46, 68, 105, 0.2)"
            borderRadius="0.5rem"
            bgcolor="rgba(217, 217, 217, 0.2)"
            display="flex"
            gridGap="1.5rem"
          >
            <Box display="flex" alignItems="center" gridGap="0.38rem">
              <div className={classes.statusCircle} style={{ backgroundColor: '#FA8A82' }} />
              <div className={classes.status}>Pending</div>
            </Box>
            <Box display="flex" alignItems="center" gridGap="0.38rem">
              <div className={classes.statusCircle} style={{ backgroundColor: '#FECA06' }} />
              <div className={classes.status}>In Progress</div>
            </Box>
            <Box display="flex" alignItems="center" gridGap="0.38rem">
              <div className={classes.statusCircle} style={{ backgroundColor: '#92C951' }} />
              <div className={classes.status}>Completed</div>
            </Box>
          </Box>
          <ButtonBase onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </ButtonBase>
        </Box>
        <BusStopUI data={busStopInfo} hold={hold} gender={gender} />
        <Box display="flex" alignItems="center" justifyContent="center" m="1.88rem" gridGap="1.25rem">
          <StyleButton width="12.5rem" height="2.875rem" text="Close" onClick={handleClose} />
          <StyleButton
            width="12.5rem"
            height="2.875rem"
            text="Ack. History"
            type="fill"
            onClick={() => setShowHistory(true)}
          />
        </Box>
      </Box>
    </Dialog>
  );
}

export default BusStopPopup;
